document.addEventListener('DOMContentLoaded', () => {
  const pillarSlider = () => {
    new Swiper('.brand-pillar__slider', {
      spaceBetween: 30,
      slidesPerView: 1.3,
      watchOverflow: true,
      navigation: {
        nextEl: '.press-swiper__next',
        prevEl: '.press-swiper__prev'
      },
      breakpoints: {
        1200: {
          slidesPerView: 4
        },
        992: {
          slidesPerView: 3.3
        },
        600: {
          slidesPerView: 2.3
        }
      }
    });

    const slides = document.querySelectorAll('.pillar_slide');
    const aos_animation = window.innerWidth <= 768
      ? 'bounce'
      : 'pillar-fade-right';
    slides.forEach((slide, index) => {
      slide.setAttribute('data-aos', aos_animation);
    });
  };

  document.addEventListener('shopify:section:load', pillarSlider);
  pillarSlider();
});